<template>
  <div class="countselector">
    <button @click="increment(-1)" class="left" :disabled="value === min"><i class="fa fa-fw fa-minus"></i></button>
    <input v-model="internalValueStr" type="number" :style="inputStyle" @blur="onBlur" />
    <button @click="increment(1)" class="right" :disabled="value === max"><i class="fa fa-fw fa-plus"></i></button>
  </div>
</template>

<script>
export default {
  name: 'CountSelector',
  props: {
    value: {
      required: true
    },
    expectedLength: {
      required: false,
      default: 3
    },
    min: {
      type: Number,
      required: false,
      default: null
    },
    max: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      internalValue: 0
    }
  },
  computed: {
    inputStyle () {
      return `flex-basis:${this.expectedLength * 0.6 + 1}rem`
    },
    isValid () {
      return !isNaN(this.internalValue)
    },
    internalValueStr: {
      get () {
        return this.internalValue
      },
      set (v) {
        this.internalValue = parseInt(v)
      }
    }
  },
  methods: {
    increment (qta) {
      if (!qta) {
        qta = 1
      }
      this.internalValue += qta
      if (this.min !== null) {
        this.internalValue = Math.max(this.min, this.internalValue)
      }
      if (this.max !== null) {
        this.internalValue = Math.min(this.max, this.internalValue)
      }
    },
    onBlur () {
      if (!this.isValid) {
        this.internalValue = this.value
      }
    }
  },
  mounted () {
    this.internalValue = this.value
  },
  watch: {
    internalValue (newV) {
      if (this.isValid && this.internalValue !== this.value) {
        this.$emit('input', newV)
      }
    },
    value (newV) {
      this.internalValue = newV
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/_vars.scss';

$bWidth: 2.5rem;

.countselector {
  display: flex;
  flex-direction: row;
  // justify-content: center;
  align-items: stretch;
  flex-basis: auto;
  flex: 0 0 $bWidth*2 + 1rem;
  border: 1px solid --black;
  border-radius: .3rem;
  width: $bWidth*2 + 1rem;

  input {
    margin: 0;
    border: none;
    text-align: center;
    height: 2rem;
  }

  button {
    height: 100%;
    margin: 0;
    line-height: 1rem;
    padding: .5rem;
    border: none;
    border-radius: 0;

    width: $bWidth;
    padding-left: 0;
    padding-right: 0;
  }

  & > button,
  & > input {
    border-left: 1px solid --black;

    &:nth-child(1) {
      border-left: none;
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}

</style>
